import { render, staticRenderFns } from "./challanDetails.vue?vue&type=template&id=25809035&"
import script from "./challanDetails.vue?vue&type=script&lang=js&"
export * from "./challanDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports